import React, { PureComponent } from 'react'
import { Field } from 'redux-form'
import { Row } from 'react-bootstrap'
import InputText from '../../../commons/form/InputText'
import { permissions } from '../../../../constants/backendIds'

class PaperworkAddress extends PureComponent {
  constructor (props) {
    super()
  }

  render () {
    const {
      t, readOnlyFields, fieldsConfiguration, formInitRoute
    } = this.props
    const tKey = 'DOSSIER_COMPONENTS.PAPERWORK.ADDRESS.'
    return (
      <Row>
        {(!fieldsConfiguration || (fieldsConfiguration.paperworkAddressAddress && fieldsConfiguration.paperworkAddressAddress.permission !== permissions.hidden)) && (
          <Field
            id="paperworkAddressAddress"
            name={formInitRoute + 'dossierPaperworkAddressComponent.address'}
            colSm={4}
            controlLabel={t(`${tKey}ADDRESS`)}
            placeholder={t(`${tKey}ADDRESS`)}
            component={InputText}
            onInputChange={(value) => this.setState({ paperworkAddressAddress: value })}
            disabled={readOnlyFields || (fieldsConfiguration && fieldsConfiguration.paperworkAddressAddress.permission !== permissions.editable)}
          />
        )}
        {(!fieldsConfiguration || (fieldsConfiguration.paperworkAddressCity && fieldsConfiguration.paperworkAddressCity.permission !== permissions.hidden)) && (
          <Field
            id="paperworkAddressCity"
            name={formInitRoute + 'dossierPaperworkAddressComponent.city'}
            colSm={4}
            controlLabel={t(`${tKey}CITY`)}
            placeholder={t(`${tKey}CITY`)}
            component={InputText}
            onInputChange={(value) => this.setState({ paperworkAddressCity: value })}
            disabled={readOnlyFields || (fieldsConfiguration && fieldsConfiguration.paperworkAddressCity.permission !== permissions.editable)}
          />
        )}
        {(!fieldsConfiguration || (fieldsConfiguration.paperworkAddressState && fieldsConfiguration.paperworkAddressState.permission !== permissions.hidden)) && (
          <Field
            id="paperworkAddressState"
            name={formInitRoute + 'dossierPaperworkAddressComponent.state'}
            colSm={4}
            controlLabel={t(`${tKey}STATE`)}
            placeholder={t(`${tKey}STATE`)}
            component={InputText}
            onInputChange={(value) => this.setState({ paperworkAddressState: value })}
            disabled={readOnlyFields || (fieldsConfiguration && fieldsConfiguration.paperworkAddressState.permission !== permissions.editable)}
          />
        )}
        <div className="clearfix" />
        {(!fieldsConfiguration || (fieldsConfiguration.paperworkAddressCp && fieldsConfiguration.paperworkAddressCp.permission !== permissions.hidden)) && (
          <Field
            id="paperworkAddressCp"
            name={formInitRoute + 'dossierPaperworkAddressComponent.cp'}
            colSm={4}
            controlLabel={t(`${tKey}CP`)}
            placeholder={t(`${tKey}CP`)}
            component={InputText}
            onInputChange={(value) => this.setState({ paperworkAddressCp: value })}
            disabled={readOnlyFields || (fieldsConfiguration && fieldsConfiguration.paperworkAddressCp.permission !== permissions.editable)}
          />
        )}
        {(!fieldsConfiguration || (fieldsConfiguration.paperworkAddressCountry && fieldsConfiguration.paperworkAddressCountry.permission !== permissions.hidden)) && (
          <Field
            id="paperworkAddressCountry"
            name={formInitRoute + 'dossierPaperworkAddressComponent.country'}
            colSm={4}
            controlLabel={t(`${tKey}COUNTRY`)}
            placeholder={t(`${tKey}COUNTRY`)}
            component={InputText}
            disabled={readOnlyFields || (fieldsConfiguration && fieldsConfiguration.paperworkAddressCountry.permission !== permissions.editable)}
          />
        )}
      </Row>
    )
  }
}

export default PaperworkAddress
